module.exports = __webpack_public_path__ + "f7b4d2b9279df8c70c959c9ac7d1702c.png";